"use strict";

import { initMenu } from '../components/menu.js';
import { initBanner } from '../components/banner.js';
import { initFooter } from '../components/footer.js';
import { isLogged, getLoggedAdmin } from '../utils.js';

const baseURL = window.location.hostname === 'localhost'
  ? 'http://localhost:3000/api/gallery'
  : `${process.env.API_URL}/gallery`;

// Fonction pour charger les images depuis le serveur
const loadExistingImages = async () => {
  try {
    const response = await fetch(`${baseURL}/images`);
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des images');
    }
    const data = await response.json();
    return data.images;
  } catch (error) {
    console.error('Erreur:', error);
    throw error;
  }
};

// Initialisation de la galerie
const initializeGallery = async () => {
  try {
    const existingImages = await loadExistingImages();
    if (existingImages.length === 0) {
      $("#nanoGallery").html("<p>Aucune image disponible pour le moment.</p>");
      return;
    }

    $('#nanoGallery').nanogallery2({
      items: existingImages.map((image) => ({
        src: image.url,
        srct: image.thumbnail,
        title: image.name,
      })),
      thumbnailDisplayTransition: "scaleDown",
      thumbnailHoverEffect2: "scale120",
      thumbnailLabel: { display: false },
      thumbnailDescription: { display: false },
      thumbnailWidth: 200,
      thumbnailHeight: "auto",
      thumbnailBaseGridHeight: 100,
      thumbnailSelectable: isLogged(),
      thumbnailLazyLoad: true,
    });

  } catch (error) {
    console.error("Erreur de chargement :", error);
    let errorMessage = "Erreur : Impossible de charger la galerie.";
    if (error.message === 'Failed to fetch') {
      errorMessage = "Erreur de connexion : Vérifiez votre connexion Internet.";
    } else if (error.message.includes('404')) {
      errorMessage = "Erreur : La galerie est introuvable.";
    }
    $("#nanoGallery").html(`
      <p>${errorMessage}</p>
      <button id="retryButton">Réessayer</button>
    `);

    $("#retryButton").on("click", () => {
      initializeGallery(); // Relance le chargement de la galerie
    });
  }
};

// Mettre à jour la galerie après l'upload
const updateGallery = async () => {
  try {
    const existingImages = await loadExistingImages();
    $('#nanoGallery').nanogallery2('destroy');
    $('#nanoGallery').nanogallery2({
      items: existingImages.map((image) => ({
        src: image.url,
        srct: image.thumbnail,
        title: image.name,
      })),
      thumbnailDisplayTransition: "scaleDown",
      thumbnailHoverEffect2: "scale120",
      thumbnailLabel: { display: false },
      thumbnailDescription: { display: false },
      thumbnailWidth: 200,
      thumbnailHeight: "auto",
      thumbnailBaseGridHeight: 100,
      thumbnailSelectable: isLogged(),
      thumbnailLazyLoad: true,
    });
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la galerie :", error);
    $("#nanoGallery").html("<p>Erreur : Impossible de mettre à jour la galerie.</p>");
  }
};

// Fonction pour uploader des images
const handleImageUpload = async (e) => {
  e.preventDefault();

  const formData = new FormData(document.getElementById("uploadForm"));
  $('#loadingSpinner').removeClass('d-none');
  $('#uploadFormSubmitBtn').prop('disabled', true);
  $('#uploadMessage').addClass('d-none'); // Cache le message précédent

  try {
    const response = await fetch(`${baseURL}/upload`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Erreur lors de l\'upload.');
    }

    $('#loadingSpinner').addClass('d-none');
    $('#uploadFormSubmitBtn').prop('disabled', false);
    $('#uploadMessage').removeClass('d-none').text('Fichiers uploadés avec succès !').removeClass('alert-danger').addClass('alert-success');
    $('#fileInput').val('');
    updateGallery();

  } catch (error) {
    $('#loadingSpinner').addClass('d-none');
    $('#uploadFormSubmitBtn').prop('disabled', false);
    $('#uploadMessage').removeClass('d-none').text(`Erreur lors de l'upload : ${error.message}`).removeClass('alert-success').addClass('alert-danger');
  }
};

const deleteSelectedImages = async () => {
  const ngy2data = $("#nanoGallery").nanogallery2('data');
  const selectedImages = ngy2data.items.filter(item => item.selected);

  if (selectedImages.length === 0) {
    alert("Aucune image sélectionnée.");
    return;
  }

  const imageIds = selectedImages.map(item => item.title);  // Utiliser le titre comme ID (ou utilisez un autre champ si nécessaire)

  const confirmation = confirm("Êtes-vous sûr de vouloir supprimer ces images ?");
  if (!confirmation) {
    return;
  }

  try {
    const response = await fetch(`${baseURL}/images`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ imageIds })  // Envoyer un tableau d'IDs d'images
    });

    if (!response.ok) {
      const data = await response.json();
      alert(`Erreur lors de la suppression : ${data.message}`);
    } else {
      alert('Les images ont été supprimées avec succès.');
      // Vous pouvez aussi mettre à jour la galerie ici après suppression si nécessaire
      //$('#nanoGallery').nanogallery2('resize');
      updateGallery();
    }
  } catch (error) {
    console.error("Erreur lors de la suppression des images:", error);
    alert("Erreur lors de la suppression des images.");
  }
};

// Fonction pour archiver les images sélectionnées
const archiveSelectedImages = async () => {
  const ngy2data = $("#nanoGallery").nanogallery2('data');
  const selectedImages = ngy2data.items.filter(item => item.selected);

  if (selectedImages.length === 0) {
    alert("Aucune image sélectionnée pour l'archivage.");
    return;
  }

  const imageIds = selectedImages.map(item => item.title);  // Utilise les noms des fichiers comme ID

  try {
    const response = await fetch(`${baseURL}/images/archive`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ imageIds }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Erreur lors de l\'archivage des images');
    }

    alert('Les images ont été archivées avec succès.');
    // Mettre à jour la galerie si nécessaire (par exemple, en supprimant les images archivées)
    //$("#nanoGallery").nanogallery2('resize');
    updateGallery();
  } catch (error) {
    console.error("Erreur lors de l'archivage des images:", error);
    alert("Erreur lors de l'archivage des images.");
  }
};

const initGallery = () => {
  console.log("Initialisation de la page de galerie");
  initBanner();
  initMenu();
  initializeGallery();
  if (isLogged()) {
    $('#buttons-container').append(`
        <button type="button" id="btn_del">Supprimer la sélection</button>
        <button type="button" id="btn_archive">Archiver la sélection</button>
    `);
    $('#btn_archive').on('click', archiveSelectedImages);
    $('#btn_del').on('click', deleteSelectedImages);
  }

  $('#uploadFormSubmitBtn').on('click', handleImageUpload);

  initFooter();
};

export { initGallery };
